/** The setup service shown on pricing and in optional article offer cards. */
export const maitoSetupOffer = {
  title: "Want it done for you?",
  price: "$2,999",
  priceTerms: "one time, on top of your $149 monthly workspace.",
  description:
    "We connect your help desk, repository, logs, and Slack, run your first 10 escalations with you, and set up the weekly escalation report. Maito is answering escalations from day one.",
  articleDescription:
    "We connect your help desk, repository, logs, Slack, and AI provider. Then we run your first 10 escalations with you, save what works as skills, and set up the weekly escalation report. Your support team starts with escalations Maito already handles, and your engineers get their afternoons back.",
  actionLabel: "Book a setup call",
  actionUrl: "mailto:support@maito.app?subject=Maito%20setup",
} as const;
